import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import {Slider} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    startEndMark: {
        color: theme.palette.text.secondary
    },
    tooltipHeader: {
        fontSize: 16,
        fontWeight: "bold",
        padding: 5
    },
    roundScoreBlueTop: {
        borderRadius: 50,
        height: 18,
        width: 18,
        fontSize: 11,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "blue",
        marginTop: -35,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    roundScoreBlueBottom: {
        borderRadius: 50,
        height: 18,
        width: 18,
        fontSize: 11,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "blue",
        marginTop: -11,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    roundScoreRedTop: {
        borderRadius: 50,
        height: 18,
        width: 18,
        fontSize: 11,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "red",
        marginTop: -35,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    roundScoreRedBottom: {
        borderRadius: 50,
        height: 18,
        width: 18,
        fontSize: 11,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "red",
        marginTop: -11,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    noMaxWidth: {
        maxWidth: 'none',
    }
}));

const VideoProgressSlider = withStyles((theme) => ({
    root: {
        height: 2
    },
    thumb: {
        height: 0,
        width: 0
    },
    active: {},
    valueLabel: {
        backgroundColor: "transparent",
    },
    track: {
        height: 0,
    },
    rail: {
        height: 2,
        opacity: 0.5,
    },
    mark: {
        height: 12,
        width: 1
    },
    markActive: {
        opacity: 1,
        backgroundColor: 'currentColor',
    },
}))(Slider);


export {useStyles, VideoProgressSlider};